import api_base from "@/api/base";
import { Role, RoleManagement } from "@/views/roles/data/schema";

export const get_roles = async (): Promise<Role[]> => {
  const response = await api_base.get("/api/v1/roles/");
  return response.data;
};
export const get_roles_list = async (): Promise<Role[]> => {
  const response = await api_base.get("/api/v1/user/role/list");
  return response.data;
};

export const create_role = async (data: Partial<RoleManagement>): Promise<Role> => {
  const response = await api_base.post("/api/v1/roles/", data);
  return response.data;
};

export const get_role = async (id: number): Promise<Role> => {
  const response = await api_base.get(`/api/v1/roles/${id}/`);
  return response.data;
};

export const update_role = async (id: number, data: Partial<RoleManagement>): Promise<Role> => {
  const response = await api_base.patch(`/api/v1/roles/${id}/`, data);
  return response.data;
};

export const delete_role = async (id: number): Promise<void> => {
  await api_base.delete(`/api/v1/roles/${id}/`);
};

export const attach_permission_to_role = async (roleId: number, permissionId: number): Promise<void> => {
  await api_base.post(`/api/v1/roles/${roleId}/permissions/${permissionId}`);
};

export const detach_permission_from_role = async (roleId: number, permissionId: number): Promise<void> => {
  await api_base.delete(`/api/v1/roles/${roleId}/permissions/${permissionId}`);
};

export const toggle_role_status = async (roleId: number): Promise<void> => {
  await api_base.post('/api/v1/cabinet-role/toggle', { role_id: roleId });
};
